import React from "react";

// Compact radio-style pill row for choosing image / video. Kept
// deliberately simple — the About hero has exactly two rendering
// paths so a native <select> would be less scannable than two
// large tap targets.
export const MediaTypeSelect = ({ value, onChange, testId }) => {
  const opts = [
    { value: "image", label: "Image" },
    { value: "video", label: "Video" },
  ];
  return (
    <div data-testid={testId} className="flex gap-2">
      {opts.map((o) => {
        const active = value === o.value;
        return (
          <button
            key={o.value}
            type="button"
            onClick={() => onChange(o.value)}
            data-testid={`${testId}-${o.value}`}
            className={`flex-1 rounded-xl border px-4 py-3 text-sm font-semibold transition-colors ${
              active
                ? "border-[#FF6600] bg-[#1A1209] text-white"
                : "border-[#262626] bg-[#141414] text-[#A3A3A3] hover:border-[#FF6600]/40"
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
};

// 3×3 focal-point picker. Each cell writes a stable token that the
// AboutPage.jsx `FOCAL_POSITIONS` map turns into a CSS
// `object-position`. Nine positions are enough for every crop the
// About hero needs without opening up the complexity of free X/Y
// sliders.
const FOCAL_GRID = [
  ["top-left",    "top",    "top-right"],
  ["left",        "center", "right"],
  ["bottom-left", "bottom", "bottom-right"],
];
export const FocalSelect = ({ value, onChange, testId }) => (
  <div data-testid={testId} className="inline-grid grid-cols-3 gap-1 rounded-xl border border-[#262626] bg-[#141414] p-1">
    {FOCAL_GRID.flat().map((token) => {
      const active = value === token;
      return (
        <button
          key={token}
          type="button"
          onClick={() => onChange(token)}
          data-testid={`${testId}-${token}`}
          title={token}
          className={`w-10 h-10 rounded-md border transition-colors ${
            active
              ? "border-[#FF6600] bg-[#FF6600]"
              : "border-[#333] bg-[#0F0F0F] hover:border-[#FF6600]/40"
          }`}
        />
      );
    })}
  </div>
);
